<div class="segmented-timepicker-container">
   <label class="segmented-timepicker-label">{{ label }}{{ required ? '*' : null }}</label>
   <div class="segmented-timepicker">
      <input
         #hoursInput
         matInput
         type="number"
         maxlength="2"
         placeholder="HH"
         [required]="required"
         [value]="hours"
         [disabled]="isDisabled"
         (focus)="selectAll(hoursInput)"
         (input)="onHoursInput($event.target.value)"
         (blur)="onTouched(); parseShorthandOnBlur()"
         (keydown)="onArrowKey($event, 'hours')"
      />
      :
      <input
         #minutesInput
         matInput
         type="number"
         maxlength="2"
         placeholder="MM"
         [required]="required"
         [value]="minutes"
         [disabled]="isDisabled"
         (focus)="selectAll(minutesInput)"
         (input)="onMinutesInput($event.target.value)"
         (blur)="onTouched(); parseShorthandOnBlur()"
         (keydown)="onArrowKey($event, 'minutes')"
      />
      <input
         #ampmInput
         matInput
         type="text"
         maxlength="2"
         placeholder="AM"
         [required]="required"
         [value]="ampm"
         [disabled]="isDisabled"
         (focus)="selectAll(ampmInput)"
         (blur)="ampm = ampm || 'AM'; onTouched(); parseShorthandOnBlur()"
         (input)="onAmPmInput($event.target.value)"
         (keydown)="onArrowKey($event, 'ampm')"
      />
   </div>
</div>
